import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(cents: number | null | undefined): string {
  if (!cents) return "$0.00";
  return `$${(cents / 100).toFixed(2)}`;
}

export function dollarsToCents(dollars: number | string | undefined | null): number {
  if (!dollars) return 0;
  const num = typeof dollars === 'string' ? parseFloat(dollars) : dollars;
  return Math.round(num * 100);
}

export function centsToDollars(cents: number | null | undefined): number {
  if (!cents) return 0;
  return cents / 100;
}
